var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticStyle:{"position":"absolute","right":"50px","bottom":"0px"}},[_vm._v("备案号：苏ICP备20010784号")])])
}]

export { render, staticRenderFns }